import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ConnectorContext } from '../context';
import { DEFAULTS } from '../utils';

// Older builds stored a missing logo as the string "null" or "undefined".
const NO_LOGO = ['null', 'undefined', ''];
export const readStoredClientLogo = () => {
  const stored = sessionStorage.getItem('clientLogo');
  return NO_LOGO.includes(stored) ? null : stored;
};

const initialState = {
  region: DEFAULTS.LANG,
  isLoading: true,
  error: false,
  clientLogoUrl: null,
  preStartConnection: {
    isReadyToConnect: false,
  },
  triggeredEvents: [],
};

export const WithConnectorContext = ({ children }) => {
  const [state, setState] = useState(() => ({
    ...initialState,
    clientLogoUrl: readStoredClientLogo(),
  }));

  const setConnectorState = (updatedState) => {
    setState((prevState) => ({ ...prevState, ...updatedState }));
  };

  const context = useMemo(
    () => ({
      state,
      updateState: setConnectorState,
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(state)]
  );

  return <ConnectorContext.Provider value={context}>{children}</ConnectorContext.Provider>;
};

WithConnectorContext.propTypes = {
  children: PropTypes.element.isRequired,
};
